import cls from 'classnames';
import React from 'react';

interface IPrices {
  isMultiline: boolean;
  price: number;
  type: string;
  currency: string;
}

interface IProps {
  prices: IPrices[];
}

export default function ProductPrice(props: IProps) {
  const { prices } = props;

  return (
    <div className="tag-price">
      {prices.map(({ currency, price, isMultiline, type }, arrIndex) => {
        return (
          <span
            key={arrIndex}
            className={cls(
              type === 'sale' ? 'tag sale' : 'normal',
              isMultiline && 'is-multiline',
            )}
          >
            {price}
            <small>kr</small>
          </span>
        );
      })}
    </div>
  );
}

ProductPrice.defaultProps = {
  currency: 'KR',
  color: 'red',
};
